<template>
  <div>
    <!-- VERIFY CARD -->
    <div
      class="verify-card w-100 h-auto d-flex justify-content-between align-items-center nowrap white"
    >
      <div
        class="verify-detail d-flex justify-content-start align-items-center nowrap"
      >
        <!-- AVATAR   -->
        <div class="avatar avatar_md">
          <div class="avatar-text white-text" :class="setAvatarBg">
            {{ getInitial }}
          </div>
        </div>
        <!-- INFO -->
        <div class="verify-info">
          <div class="name font-weight-900 color_text text-capitalize">
            {{ fullname }}
          </div>
          <!-- VERIFY TYPE -->
          <div class="meta color_grey_dark font-13" v-if="verify_type">
            <span>Wants to Join &nbsp;</span>
            <span class="color_text font-weight-900">{{ class_name }}</span>
          </div>

          <!-- INVITATION TYPE -->
          <div class="meta color_grey_dark font-13" v-else>
            <span>Invited to Teach &nbsp;</span>
            <span class="color_text font-weight-900">{{
              getClassSubject
            }}</span>
            <span>&nbsp;to&nbsp;</span>
            <span class="color_text font-weight-900">{{ class_name }}</span>
          </div>
        </div>
      </div>

      <!-- VERIFY ACTION -->
      <div
        class="verify-action d-flex justify-content-between align-items-center flex-wrap"
      >
        <!-- APPROVE ICON -->
        <div
          v-if="verify_type"
          class="avatar approve-box pointer"
          @click="$emit('approve-teacher', { id: id, name: fullname })"
        >
          <span class="flex-center icon-accept brand_primary font-20"></span>
        </div>
        <!-- DECLINE ICON -->
        <div
          v-if="verify_type"
          class="avatar decline-box pointer"
          @click="$emit('decline-teacher', { id: id, name: fullname })"
        >
          <span class="flex-center icon-decline brand_tonic font-20"></span>
        </div>

        <!-- RESTART ICON -->
        <div
          v-if="!verify_type"
          class="avatar approve-box pointer"
          @click="$emit('resend-invitation', id)"
          title="Resend Invitation"
        >
          <span class="flex-center icon-swap brand_primary font-17"></span>
        </div>
        <!-- CANCEL ICON -->
        <div
          v-if="!verify_type"
          class="avatar decline-box pointer"
          @click="$emit('cancel-invitation', id)"
          title="Cancel Invitation"
        >
          <span class="flex-center icon-decline brand_tonic font-20"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { setInitial } from "@/scripts/utilities";
import { setProfileBg } from "@/scripts/profile-colors";

export default {
  name: "VerifyTeacherCard",

  props: {
    id: Number,
    fullname: String,
    class_name_id: Number,
    class_subject: Array,
    verify_type: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    getInitial() {
      return setInitial(this.fullname);
    },

    setAvatarBg() {
      return setProfileBg(this.fullname);
    },

    getClassSubject() {
      let subjects = [];
      this.class_subject.map((subject) => {
        subjects.push(subject.name);
      });

      if (subjects.length > 1) {
        let last_subject = subjects.pop();
        let initial_subject = subjects.join(", ");
        return `${initial_subject} and ${last_subject}`;
      } else if (subjects.length === 1) return subjects[0];
      else return false;
    },
  },

  data() {
    return {
      class_name: "not available",
    };
  },

  mounted() {
    this.fetchClassname();
  },

  methods: {
    ...mapActions(["getSingleClass"]),

    fetchClassname() {
      if (this.class_name_id) {
        this.getSingleClass(this.class_name_id)
          .then((response) => {
            if (response.code === 200) {
              this.class_name = response.data.class_name;
            }
          })
          .catch((err) => console.log(err));
      }
    },
  },
};
</script>

<style lang="scss">
// VERIFICATION CARD
.verify-card {
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  padding: 15px;
  padding-right: 10px;
  margin-bottom: 5px;

  @include breakpoint_max(md) {
    padding: 10px;
    padding-right: 10px;
    padding-left: 13px;
  }

  .verify-detail {
    width: 74%;
    padding-right: 15px;

    .avatar {
      margin-right: 15px;
    }

    .name {
      margin-bottom: 2px;

      @include breakpoint_max(md) {
        font-size: 14px;
      }

      @include breakpoint_max(sm) {
        font-size: 13px;
      }
    }

    .meta {
      line-height: 22px;
      @include breakpoint_max(md) {
        font-size: 12px !important;
      }

      @include breakpoint_max(sm) {
        font-size: 11.5px !important;
      }
    }
  }

  .verify-action {
    @include breakpoint_max(lg) {
      @include flex_column_center;
    }

    .approve-box {
      background-color: #dbf5f8;
      margin-right: 15px;
      transition: background-color 0.3s ease-in-out;

      &:hover {
        background-color: darken(#dbf5f8, 10%);
      }

      @include breakpoint_max(lg) {
        margin-right: 0px;
        margin-bottom: 5px;
      }
    }

    .decline-box {
      background-color: #ffdcde;
      margin-left: 15px;
      transition: background-color 0.3s ease-in-out;

      &:hover {
        background-color: darken(#ffdcde, 5%);
      }

      @include breakpoint_max(lg) {
        margin-left: 0px;
        margin-top: 5px;
      }
    }

    .approve-box,
    .decline-box {
      @include breakpoint_max(sm) {
        span {
          font-size: 17px !important;
        }
      }
    }
  }
}
</style>
